// DepartmentRole.jsx

import React, { useState } from "react";
import CreatableSelect from "react-select/creatable";

function DepartmentRole() {
  const [department, setDepartment] = useState([]);

  // Sample data for Department
  const DepartmentList = [
    {
      value: "Software Development > Frontend Developer",
      label: "Software Development > Frontend Developer",
    },
    {
      value: "Software Development > Backend Developer",
      label: "Software Development > Backend Developer",
    },
    {
      value: "Software Development > Full Stack Developer",
      label: "Software Development > Full Stack Developer",
    },
    {
      value: "Software Development > DevOps Engineer",
      label: "Software Development > DevOps Engineer",
    },
    {
      value: "Software Development > Quality Assurance Engineer",
      label: "Software Development > Quality Assurance Engineer",
    },

    {
      value: "Data Science > Data Analyst",
      label: "Data Science > Data Analyst",
    },
    {
      value: "Data Science > Data Scientist",
      label: "Data Science > Data Scientist",
    },
    {
      value: "Data Science > Machine Learning Engineer",
      label: "Data Science > Machine Learning Engineer",
    },
    {
      value: "Data Science > Data Engineer",
      label: "Data Science > Data Engineer",
    },

    { value: "Sales > Sales Executive", label: "Sales > Sales Executive" },
    { value: "Sales > Sales Manager", label: "Sales > Sales Manager" },
    { value: "Sales > Account Manager", label: "Sales > Account Manager" },
    {
      value: "Sales > Business Development Manager",
      label: "Sales > Business Development Manager",
    },

    {
      value: "Human Resources > HR Manager",
      label: "Human Resources > HR Manager",
    },
    {
      value: "Human Resources > Recruiter",
      label: "Human Resources > Recruiter",
    },
    {
      value: "Human Resources > Talent Acquisition Specialist",
      label: "Human Resources > Talent Acquisition Specialist",
    },
    {
      value: "Human Resources > Training & Development Manager",
      label: "Human Resources > Training & Development Manager",
    },

    {
      value: "Finance > Financial Analyst",
      label: "Finance > Financial Analyst",
    },
    { value: "Finance > Accountant", label: "Finance > Accountant" },
    { value: "Finance > Controller", label: "Finance > Controller" },
    {
      value: "Finance > Chief Financial Officer",
      label: "Finance > Chief Financial Officer",
    },

    {
      value: "Marketing > Marketing Manager",
      label: "Marketing > Marketing Manager",
    },
    {
      value: "Marketing > Digital Marketing Specialist",
      label: "Marketing > Digital Marketing Specialist",
    },
    {
      value: "Marketing > Content Creator",
      label: "Marketing > Content Creator",
    },
    {
      value: "Marketing > SEO Specialist",
      label: "Marketing > SEO Specialist",
    },

    {
      value: "Customer Service > Customer Service Representative",
      label: "Customer Service > Customer Service Representative",
    },
    {
      value: "Customer Service > Customer Success Manager",
      label: "Customer Service > Customer Success Manager",
    },
    {
      value: "Customer Service > Technical Support Specialist",
      label: "Customer Service > Technical Support Specialist",
    },

    {
      value: "Operations > Operations Manager",
      label: "Operations > Operations Manager",
    },
    {
      value: "Operations > Supply Chain Manager",
      label: "Operations > Supply Chain Manager",
    },
    {
      value: "Operations > Logistics Coordinator",
      label: "Operations > Logistics Coordinator",
    },

    { value: "Legal > Corporate Lawyer", label: "Legal > Corporate Lawyer" },
    {
      value: "Legal > Compliance Officer",
      label: "Legal > Compliance Officer",
    },
    { value: "Legal > Legal Assistant", label: "Legal > Legal Assistant" },

    {
      value: "Engineering > Mechanical Engineer",
      label: "Engineering > Mechanical Engineer",
    },
    {
      value: "Engineering > Electrical Engineer",
      label: "Engineering > Electrical Engineer",
    },
    {
      value: "Engineering > Civil Engineer",
      label: "Engineering > Civil Engineer",
    },
    {
      value: "Engineering > Structural Engineer",
      label: "Engineering > Structural Engineer",
    },

    {
      value: "Product Management > Product Manager",
      label: "Product Management > Product Manager",
    },
    {
      value: "Product Management > Product Owner",
      label: "Product Management > Product Owner",
    },
    {
      value: "Product Management > Product Analyst",
      label: "Product Management > Product Analyst",
    },

    { value: "Education > Teacher", label: "Education > Teacher" },
    {
      value: "Education > Academic Advisor",
      label: "Education > Academic Advisor",
    },
    {
      value: "Education > Research Assistant",
      label: "Education > Research Assistant",
    },

    { value: "Healthcare > Nurse", label: "Healthcare > Nurse" },
    {
      value: "Healthcare > Medical Doctor",
      label: "Healthcare > Medical Doctor",
    },
    { value: "Healthcare > Pharmacist", label: "Healthcare > Pharmacist" },
    {
      value: "Healthcare > Medical Assistant",
      label: "Healthcare > Medical Assistant",
    },

    { value: "Design > Graphic Designer", label: "Design > Graphic Designer" },
    { value: "Design > UX/UI Designer", label: "Design > UX/UI Designer" },
    { value: "Design > Product Designer", label: "Design > Product Designer" },

    {
      value: "Research & Development > Research Scientist",
      label: "Research & Development > Research Scientist",
    },
    {
      value: "Research & Development > Lab Technician",
      label: "Research & Development > Lab Technician",
    },
    {
      value: "Research & Development > Research Assistant",
      label: "Research & Development > Research Assistant",
    },
  ];
  // Function to handle selection change
  const handleDepartmentChange = (selectedOptions) => {
    setDepartment(selectedOptions || []);
  };

  return (
    <div className="mb-4">
      <label className="block text-gray-700 font-bold mb-2">
        Department/Role
      </label>
      <CreatableSelect
        isMulti
        options={DepartmentList}
        value={department}
        onChange={handleDepartmentChange}
        placeholder="Type a Department and select..."
        className="mb-4"
      />
    </div>
  );
}

export default DepartmentRole;
